// extracted by mini-css-extract-plugin
module.exports = {"vGray2":"#f4f5f7","desc":"PostContentTextArea_desc__29EKu","textarea":"PostContentTextArea_textarea__2aA1L"};